import { render, staticRenderFns } from "./consignorResourcesCarAddAccount.vue?vue&type=template&id=1aec5be6&scoped=true&"
import script from "./consignorResourcesCarAddAccount.vue?vue&type=script&lang=js&"
export * from "./consignorResourcesCarAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./consignorResourcesCarAddAccount.vue?vue&type=style&index=0&id=1aec5be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec5be6",
  null
  
)

export default component.exports